<template>
  <div>
    <h5>Distributed Temperature Sensing (DTS)</h5>
    <DTSChartComponent :data="chartData" :areaOfInterest="areaOfInterest" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue'
import { Alarm, AlarmClient, AreaOfInterest, DTSChart } from '@/server/MakeSenseApp-backend'
import DTSChartComponent from '../DTSChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'

const props = defineProps({
  alarm: Alarm
})

const chartData = ref<DTSChart | undefined>(undefined)
const areaOfInterest = ref<AreaOfInterest | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  alarmClient.dtsForAlarm(store.projectId, props.alarm.id).then((data) => {
    chartData.value = data as DTSChart
    areaOfInterest.value = data.areaOfInterest
  })
})
</script>

<style scoped></style>
